import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=6a6eb16f&scoped=true"
import script from "./NewGroup.vue?vue&type=script&lang=js"
export * from "./NewGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6eb16f",
  null
  
)

export default component.exports